export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/signup";
export const LOGINPAGE = "/login";
export const GIFTS = "/gifts-list";
